<template>
  <div class="card mb-3">
    <h4 class="card-header">
      Week
    </h4>
    <div class="card-body">
      <p>
        <a
          class="btn btn-primary"
          data-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >Select Week</a>
      </p>
      <div
        id="collapseExample"
        class="collapse"
      > 
        <div class="nav d-flex flex-row">         
          <button
            v-for="n in 12"
            :key="n"
            class="nav-item btn-light btn p-2 m-0 hover-pointer text-white"  
            :class="{'bg-green' : $route.query.week == n, 'bg-green-fade': $route.query.week != n}" 
            @click.prevent="toggleCategory(n)"
          >
            Week {{ n }}
          </button>
        </div>         
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toggleCategory(week) {
      // Unsetting
      if (this.$route.query.week == week) {
        this.unsetCategory();
      } else {
        this.setCategory(week);
      }
    },
    setCategory(week) {
      this.$router.push({
        query: { week: week }
      });
    },
    unsetCategory() {
      let query = Object.assign({}, this.$route.query);
      delete query.week;
      this.$router.replace({ query });
    }
  }
};
</script>